import { Type } from 'class-transformer';
import { sumBy } from 'lodash';
import OrderObservationModel from '@/models/crm/order-observation.model';
import OrderItemModel from '@/models/crm/order-item.model';
import OrderFiscalDocumentModel from '@/models/crm/order-fiscal-document.model';
import OrderHistoryModel from '@/models/crm/order-history.model';

export default class OrderModel {
  codCliente!: string;

  codEmpresa!: string;

  codNotaFiscal!: string;

  dataEmissaoNotaFiscal?: string;

  codPedido!: string;

  @Type(() => Date)
  dataEmissao!: Date;

  @Type(() => Date)
  dataPrevFaturamento!: Date;

  motivoSuspensao?: string;

  motivoCancelamento?: string;

  idDataSource!: number;

  nomeDataSource!: string;

  situacao!: string;

  valorBruto!: number;

  valorLiquido!: number;

  valorSaldo!: number;

  qtdeCancelada!: number;

  valorDesconto?: number;

  cnpj?: string;

  inscricaoEstadual?: string;

  nomeCliente?: string;

  nomeRedespacho?: string;

  nomeRepres?: string;

  nomeTransp?: string;

  observacao?: string;

  percComissao?: number;

  percDesconto1?: number;

  tabPreco?: string;

  tipoFreteTransp?: string;

  tipoNota?: string;

  uf?: string;

  valorFaturado?: number;

  qtdPecas?: number;

  @Type(() => OrderHistoryModel)
  historico?: OrderHistoryModel[];

  @Type(() => OrderItemModel)
  itens!: OrderItemModel[];

  @Type(() => OrderObservationModel)
  observacoes!: OrderObservationModel[];

  @Type(() => OrderFiscalDocumentModel)
  notasFiscais!: OrderFiscalDocumentModel[];

  coringa1?: string;

  get qtdeItens(): number {
    return sumBy(this.itens || [], 'qtdePedida');
  }

  get qtdeItensCancelados(): number {
    return sumBy(this.itens || [], 'qtdeCancelado');
  }

  get qtdeItensFaturados(): number {
    return Number(sumBy(this.itens || [], 'qtdeFaturado').toFixed(2));
  }

  get totalBrutoItens(): number {
    return sumBy(this.itens || [], ((i) => (i.valorUnitarioBruto * i.qtdeFaturado)));
  }

  get totalLiquidoItens(): number {
    return sumBy(this.itens || [], ((i) => (i.valorUnitarioLiquido * i.qtdeFaturado)));
  }

  get totalSaldoItens(): number {
    return Number(sumBy(this.itens || [], 'totalSaldo').toFixed(2));
  }

  get totalFaturadoItens(): number {
    return sumBy(this.itens || [], 'totalFaturado');
  }

  get totalItens(): number {
    return sumBy(this.itens || [], 'valorTotal');
  }
}
